export function sizeNavbar() {
  const sitesWithoutTopCookies = ['ausopen', 'clash', 'lcsc', 'liv', 'motogp', 'mse', 'nascar', 'nba-exp', 'amex']

  if ($('.cookie-consent-dropdown').length == 0 || sitesWithoutTopCookies.includes(window.name)) { return }

  $('.navbar-fixed-top').css('top', 0)
  $('.navbar-fixed-top .navbar-default').css('top',
    `${$('.cookie-fixed-top .nav-cookies').height()}px`)
}
